// 현재 앱 버전 조회 — Tauri 데스크톱이면 native API, 웹이면 빌드타임 env 또는 'web'
let cached: string | null = null;

export async function getAppVersion(): Promise<string> {
  if (cached) return cached;
  try {
    const { getVersion } = await import('@tauri-apps/api/app');
    cached = await getVersion();
  } catch {
    cached = process.env.REACT_APP_VERSION || 'web';
  }
  return cached!;
}
